import { render } from "./SmartcardNotificationTimeframes.vue?vue&type=template&id=05f83d2e&scoped=true"
import script from "./SmartcardNotificationTimeframes.vue?vue&type=script&lang=js"
export * from "./SmartcardNotificationTimeframes.vue?vue&type=script&lang=js"

import "./SmartcardNotificationTimeframes.vue?vue&type=style&index=0&id=05f83d2e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05f83d2e"

export default script